import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import ModernNavbar from "./ModernNavbar";
import Footer from "./Footer";

import Newsletter from "../components/Newsletter";

const pageVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94], // Custom easing for smoother feel
    },
  },
  out: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.4,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

const Layout = ({ children }) => {
  const location = useLocation();


  const authLikeRoutes = ['/login', '/register', '/forgotpassword', '/mobile/forgotpassword'];
  const hideNewsletter = authLikeRoutes;
  const showNewsletter = !hideNewsletter.includes(location.pathname);
  const showFooter = !authLikeRoutes.includes(location.pathname);

  return (
    <HelmetProvider>
      <div className="app-container">
        <Helmet>
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/img/logosmall.svg"
          />
          <link
            rel="icon"
            type="image/png"
            href="/img/logosmall.svg"
            sizes="32x32"
          />
          <link
            rel="icon"
            type="image/png"
            href="/img/logosmall.svg"
            sizes="16x16"
          />
          <link
            rel="mask-icon"
            href="/img/logosmall.svg"
            color="#ff4400"
          />
          <meta name="theme-color" content="#fff" />
          <meta property="og:type" content="business.business" />
                  <meta property="og:title" content="Saturnalia" />
        <meta property="og:description" content="The modern day mystery school" />
        <meta property="og:url" content="www.Saturnalia.org" />
          <meta property="og:image" content="/img/logosmall.svg" />
        </Helmet>
        
        <div className="navbar-fade-in">
        <ModernNavbar />
        </div>
        
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            className="page-content"
            style={{ position: 'relative' }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
        
        {showNewsletter && <Newsletter />}
        {/* <AI /> */}
        {showFooter && <Footer />}
      </div>
    </HelmetProvider>
  );
};

export default Layout;
